export default "/static/img/layers/topo-osm-wms.826bbefca09fdc1e08d77c56f5e8a935.png";